(function () {
  var TELEFON = 750;
  var INSET = 8;
  var ODSTEP = 12;

  function daneSlajdu(slide, szerokosc) {
    var zestaw = slide && slide.dataset ? slide.dataset : {};
    var telefon = szerokosc < TELEFON;
    var srcMobile = zestaw.srcMobile || "";
    var srcDesktop = zestaw.src || "";
    var uzyjMobile = telefon && srcMobile !== "";
    var src = uzyjMobile ? srcMobile : (telefon ? (srcMobile || srcDesktop) : srcDesktop);
    if (!src) return null;

    var width = Number(uzyjMobile ? zestaw.wMobile : zestaw.w);
    var height = Number(uzyjMobile ? zestaw.hMobile : zestaw.h);
    if (!width || !height) return null;

    var alt = uzyjMobile ? (zestaw.altMobile || zestaw.alt || "") : (zestaw.alt || "");
    return { src: src, width: width, height: height, alt: alt };
  }

  // Strzałki tuż obok zdjęcia. Gdy brakuje miejsca (wąski ekran, szerokie zdjęcie),
  // wchodzą na krawędź zdjęcia, żeby nie wypaść poza ekran.
  function polozenieStrzalek(rect, buttonWidth, buttonHeight, viewportWidth) {
    var top = rect.top + rect.height / 2 - buttonHeight / 2;
    var prevLeft = rect.left - buttonWidth - ODSTEP;
    var nextLeft = rect.right + ODSTEP;
    if (prevLeft < INSET) prevLeft = rect.left + INSET;
    if (nextLeft + buttonWidth > viewportWidth - INSET) {
      nextLeft = rect.right - buttonWidth - INSET;
    }
    return {
      prevLeft: Math.round(prevLeft),
      nextLeft: Math.round(nextLeft),
      top: Math.round(top)
    };
  }

  function polozenieKrzyzyka(rect, closeWidth) {
    return {
      left: Math.round(rect.right - closeWidth - INSET),
      top: Math.round(rect.top + INSET)
    };
  }

  function prostokatZdjecia(pswp) {
    var slide = pswp && pswp.currSlide;
    if (!slide || !pswp.element) return null;

    var pswpRect = pswp.element.getBoundingClientRect();
    var candidates = [];

    if (slide.width && slide.currZoomLevel) {
      var width = slide.width * slide.currZoomLevel;
      var height = slide.height * slide.currZoomLevel;
      var panX = slide.pan && typeof slide.pan.x === "number" ? slide.pan.x : 0;
      var panY = slide.pan && typeof slide.pan.y === "number" ? slide.pan.y : 0;
      var left = panX;
      var top = panY;
      if (slide.holderElement) {
        var holder = slide.holderElement.getBoundingClientRect();
        left = holder.left + panX - pswpRect.left;
        top = holder.top + panY - pswpRect.top;
      }
      if (width > 8 && height > 8) {
        candidates.push({ left: left, top: top, width: width, height: height, right: left + width, bottom: top + height });
      }
    }

    var img =
      (slide.container && slide.container.querySelector("img.pswp__img")) ||
      (slide.holderElement && slide.holderElement.querySelector("img.pswp__img"));
    if (img && img.naturalWidth && img.naturalHeight) {
      var box = img.getBoundingClientRect();
      var scale = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
      var imgWidth = img.naturalWidth * scale;
      var imgHeight = img.naturalHeight * scale;
      var imgLeft = box.left + (box.width - imgWidth) / 2 - pswpRect.left;
      var imgTop = box.top + (box.height - imgHeight) / 2 - pswpRect.top;
      if (imgWidth > 8 && imgHeight > 8) {
        candidates.push({
          left: imgLeft,
          top: imgTop,
          width: imgWidth,
          height: imgHeight,
          right: imgLeft + imgWidth,
          bottom: imgTop + imgHeight
        });
      }
    }

    if (!candidates.length) return null;
    candidates.sort(function (a, b) { return a.width - b.width; });
    return candidates[0];
  }

  function przypnij(el, left, top) {
    if (!el) return;
    el.style.setProperty("position", "absolute", "important");
    el.style.setProperty("inset", "auto", "important");
    el.style.setProperty("left", Math.round(left) + "px", "important");
    el.style.setProperty("right", "auto", "important");
    el.style.setProperty("top", Math.round(top) + "px", "important");
    el.style.setProperty("margin", "0", "important");
    el.style.setProperty("transform", "none", "important");
  }

  function ustawStrzalki(pswp) {
    if (!pswp || !pswp.element) return;

    var prev = pswp.element.querySelector(".pswp__button--arrow--prev");
    var next = pswp.element.querySelector(".pswp__button--arrow--next");
    var close = pswp.element.querySelector(".pswp__button--close");
    if (!prev && !next && !close) return;

    var rect = prostokatZdjecia(pswp);
    if (!rect) return;

    if (prev || next) {
      var buttonWidth = (prev && prev.offsetWidth) || (next && next.offsetWidth) || 48;
      var buttonHeight = (prev && prev.offsetHeight) || (next && next.offsetHeight) || 48;
      var arrows = polozenieStrzalek(rect, buttonWidth, buttonHeight, pswp.element.clientWidth);
      pswp.element.style.setProperty("--gabi-pswp-prev-x", arrows.prevLeft + "px");
      pswp.element.style.setProperty("--gabi-pswp-next-x", arrows.nextLeft + "px");
      pswp.element.style.setProperty("--gabi-pswp-arrow-y", arrows.top + "px");
      pswp.element.classList.add("gabi-pswp-arrows-ready");
      przypnij(prev, arrows.prevLeft, arrows.top);
      przypnij(next, arrows.nextLeft, arrows.top);
    }

    if (close) {
      if (close.parentElement !== pswp.element) pswp.element.appendChild(close);
      var closeWidth = close.offsetWidth || 36;
      var krzyzyk = polozenieKrzyzyka(rect, closeWidth);
      pswp.element.style.setProperty("--gabi-pswp-close-x", krzyzyk.left + "px");
      pswp.element.style.setProperty("--gabi-pswp-close-y", krzyzyk.top + "px");
      pswp.element.classList.add("gabi-pswp-close-ready");
      przypnij(close, krzyzyk.left, krzyzyk.top);
    }
  }

  function sluchajStrzalek(pswp) {
    if (!pswp || pswp.__gabiKaruzelaStrzalki) return;
    pswp.__gabiKaruzelaStrzalki = true;
    var sync = function () { ustawStrzalki(pswp); };
    pswp.on("openingAnimationEnd", sync);
    pswp.on("change", sync);
    pswp.on("resize", sync);
    pswp.on("loadComplete", sync);
    pswp.on("firstUpdate", sync);
    pswp.on("contentActivate", sync);
    var frame = 0;
    var tick = function () {
      sync();
      frame += 1;
      if (frame < 40) requestAnimationFrame(tick);
    };
    tick();
  }

  function paddingGalerii() {
    if (window.innerWidth < TELEFON) {
      return { top: 16, bottom: 16, left: 8, right: 8 };
    }
    return { top: 40, bottom: 40, left: 72, right: 72 };
  }

  if (typeof customElements !== "undefined" && !customElements.get("gabi-karuzela")) {
    class GabiKaruzela extends HTMLElement {
      connectedCallback() {
        if (this.dataset.gotowe === "1") return;
        this.dataset.gotowe = "1";
        var self = this;
        this.querySelectorAll(".gabi-karuzela__lupka").forEach(function (button) {
          button.addEventListener("pointerdown", function (event) {
            event.stopPropagation();
          });
          button.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            var slide = button.closest("[data-gabi-karuzela-slajd]");
            if (slide) self.otworz(slide);
          });
        });
      }

      otworz(slide) {
        if (!window.PhotoSwipe || !window.PhotoSwipeLightbox) return;
        var lightbox = this.lightbox || this.zbuduj();
        if (!lightbox) return;

        var dane = [];
        var index = -1;
        this.querySelectorAll("[data-gabi-karuzela-slajd]").forEach(function (el) {
          var item = daneSlajdu(el, window.innerWidth);
          if (!item) return;
          if (el === slide) index = dane.length;
          dane.push(item);
        });
        if (index < 0 || !dane.length) return;

        this.wstrzymaj();
        lightbox.options.dataSource = dane;
        if (lightbox.loadAndOpen(index) === false) this.wznow();
      }

      zbuduj() {
        var zamknij = this.querySelector("[data-gabi-karuzela-zamknij]");
        var poprzednie = this.querySelector("[data-gabi-karuzela-poprzednie]");
        var nastepne = this.querySelector("[data-gabi-karuzela-nastepne]");
        var lightbox = new PhotoSwipeLightbox({
          mainClass: "pswp--gabi-karuzela",
          loop: false,
          showHideAnimationType: "fade",
          bgClickAction: "close",
          imageClickAction: "close",
          tapAction: "close",
          doubleTapAction: false,
          clickToCloseNonZoomable: true,
          initialZoomLevel: "fit",
          secondaryZoomLevel: function (zoom) { return zoom.fit; },
          maxZoomLevel: 4,
          paddingFn: paddingGalerii,
          appendToEl: document.body,
          pswpModule: PhotoSwipe
        });

        lightbox.addFilter("uiElement", function (element, data) {
          if (data.name === "close" && zamknij) element.innerHTML = zamknij.innerHTML;
          else if (data.name === "arrowPrev" && poprzednie) element.innerHTML = poprzednie.innerHTML;
          else if (data.name === "arrowNext" && nastepne) element.innerHTML = nastepne.innerHTML;
          return element;
        });

        var self = this;
        lightbox.on("bindEvents", function () {
          var pswp = lightbox.pswp;
          if (!pswp) return;
          pswp.options.bgClickAction = "close";
          pswp.options.imageClickAction = "close";
          pswp.options.tapAction = "close";
          pswp.options.doubleTapAction = false;
          var zamknijZamiastZoomu = function (event) {
            event.preventDefault();
            pswp.close();
          };
          pswp.on("imageClickAction", zamknijZamiastZoomu);
          pswp.on("bgClickAction", zamknijZamiastZoomu);
          pswp.on("tapAction", zamknijZamiastZoomu);
          pswp.on("doubleTapAction", zamknijZamiastZoomu);
          sluchajStrzalek(pswp);
        });
        lightbox.on("openingAnimationEnd", function () { ustawStrzalki(lightbox.pswp); });
        lightbox.on("change", function () { ustawStrzalki(lightbox.pswp); });
        lightbox.on("beforeOpen", function () {
          document.body.classList.add("overflow-hidden");
        });
        lightbox.on("closingAnimationStart", function () {
          document.body.classList.remove("overflow-hidden");
          self.wznow();
        });

        lightbox.init();
        this.lightbox = lightbox;
        return lightbox;
      }

      wstrzymaj() {
        var el = this.querySelector("swiper-component");
        var swiper = el && el.swiper;
        this._swiper = swiper || null;
        this._wznow = false;
        if (swiper && swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
          this._wznow = true;
        }
      }

      wznow() {
        if (this._wznow && this._swiper && this._swiper.autoplay) {
          this._swiper.autoplay.start();
        }
        this._wznow = false;
      }
    }

    customElements.define("gabi-karuzela", GabiKaruzela);
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      daneSlajdu: daneSlajdu,
      polozenieStrzalek: polozenieStrzalek,
      polozenieKrzyzyka: polozenieKrzyzyka
    };
  }
})();
